import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'uikit/buttons';

import styles from '../styles/uikitContentMarkdown.module.scss';

const MarkdownHashtag = ({
  text,
  onClick,
}) => (
  <Button
    className={styles.hashtag}
    onClick={() => onClick(text)}
    variant="link"
    text={`#${text}`}
    color="primary"
  />
);

MarkdownHashtag.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default React.memo(MarkdownHashtag);
